"use client";

import { createElement } from "react";
import { cx } from "~/generated/styled-system/css";
import { reveal } from "~/generated/styled-system/recipes";
import { useReveal } from "~/hooks/useReveal";

// Map the numeric stagger step to the recipe's string delay key without a cast.
const delayKeys = {
  0: "0",
  1: "1",
  2: "2",
  3: "3"
};
/**
 * Wraps an element so it fades and eases into place when scrolled into view.
 * Renders as the tag given by `as` so semantics are preserved, and stays fully
 * visible without JS. Reveal state, shared observation, and reduced-motion
 * handling all come from `useReveal`.
 */
export function Reveal(t0) {
  const {
    as: t1,
    variant: t2,
    delay: t3,
    className,
    children,
    ...rest
  } = t0;
  const as = t1 === undefined ? "div" : t1;
  const variant = t2 === undefined ? "rise" : t2;
  const delay = t3 === undefined ? 0 : t3;
  const {
    ref
  } = useReveal();
  return createElement(as, {
    ref,
    className: cx(reveal({
      variant,
      delay: delayKeys[delay]
    }), className),
    ...rest
  }, children);
}